module.exports = __webpack_public_path__ + "static/aftershock-a55e99dd88e844bc2224a94a021de290.jpg";